import React from 'react';
import { useTreatmentContext } from '../../../../Services/TreatmentContext';
import Modal from '../../../../Components/Modal/Modal';
import Text from '../../../../Components/Base/Text/Text';
import { useNCZIContext } from '../../Services/NCZIContext';
import Button from '../../../../Components/Button/Button';
import { Theme } from '../../../../Enums/Theme.enum';

// @ts-ignore
import styles from './PatientNonPayerModal.module.scss';

interface Props {
  opened: boolean;
  onClose: () => void;
}

const PatientNonPayerModal: React.FC<Props> = props => {
  const { opened, onClose } = props;
  const { isCase } = useTreatmentContext();
  const { deferredZsEligibility } = useNCZIContext();

  return (
    <Modal
      opened={opened}
      onClose={onClose}
      fullScreen={false}
      wrapChat={isCase}>
      <Modal.Header title={'nczi.verifyPatientInsurance.title'} />
      <Modal.Content>
        <Text tx={'nczi.verifyPatientInsurance.patientIsNonPayer'} />
        {deferredZsEligibility && <Text tx={'nczi.verifyPatientInsurance.haveDeferredZsEligibility'} />}
        {!deferredZsEligibility && <Text tx={'nczi.verifyPatientInsurance.notHaveDeferredZsEligibility'} />}
        <div className={styles.controls}>
          <Button title={'base.shared.continue'} theme={Theme.GREEN} onClick={onClose} className={styles.button}/>
        </div>
      </Modal.Content>
    </Modal>
  );
};

export default PatientNonPayerModal;
